import { Grid } from "@mui/material";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

type BoothItem = {
  title: string;
  url: string;
  image: string;
  price: number;
};

const items: BoothItem[] = [
  {
    title: "アクリルスタンド",
    url: "https://kanami-official.booth.pm/items/7718865",
    image: "https://booth.pximg.net/d6e1e2a9-0531-4d6a-9fc1-097c37ad0572/i/7718865/d59ed0ae-6bf5-4363-a5cc-12f84736a5ca_base_resized.jpg",
    price: 2500,
  },
  {
    title: "アクリルキーホルダー",
    url: "https://kanami-official.booth.pm/items/7718874",
    image: "https://booth.pximg.net/d6e1e2a9-0531-4d6a-9fc1-097c37ad0572/i/7718874/80422e62-c7c4-4485-87ec-6c71f6f057a0_base_resized.jpg",
    price: 900,
  },
  {
    title: "ハッキングTシャツ",
    url: "https://kanami-official.booth.pm/items/7718890",
    image: "https://booth.pximg.net/d6e1e2a9-0531-4d6a-9fc1-097c37ad0572/i/7718890/bf67149f-ab18-4564-ac9b-3240f0c985f8_base_resized.jpg",
    price: 4000,
  },
  {
    title: "ランダム缶バッジ",
    url: "https://kanami-official.booth.pm/items/7718901",
    image: "https://booth.pximg.net/d6e1e2a9-0531-4d6a-9fc1-097c37ad0572/i/7718901/b6a2ec12-30de-476d-bbc1-1266e042e845_base_resized.jpg",
    price: 500,
  },
  {
    title: "キラキラステッカー",
    url: "https://kanami-official.booth.pm/items/7718906",
    image: "https://booth.pximg.net/d6e1e2a9-0531-4d6a-9fc1-097c37ad0572/i/7718906/d59ecece-6c91-40f7-90fb-4d923d426394_base_resized.jpg",
    price: 200,
  },
  
];

const Shop = (props :any) => {
  return (
    <div className='content-wrap'>
      <div className='title'>-SHOP-</div>
      <Grid container spacing={3} className="item-container">
        {items.map((item) => (
          <Grid size={{xs:6, sm:4, md:3}} className="shop-card">
            <a
              key={item.url}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="item-link"
            >
              <div className="shop-image">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="shop-meta">
                <div className="shop-title">{item.title}</div>
                <div className="shop-price">
                  <ShoppingCartIcon sx={{fontSize: '14px', padding: '1px 1.5px', marginRight: '3px', color: '#fff', backgroundColor: '#7dafdf', borderRadius: '2px'}}/>
                  ￥{item.price.toLocaleString()}
                </div>
              </div>
            </a>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Shop;